export default "__VITE_ASSET__GgUqcEAB__"